import Vue from 'vue'
////import BootstrapVue from 'bootstrap-vue'

import { BootstrapVue, IconsPlugin, BootstrapVueIcons } from 'bootstrap-vue'
import { BButton } from 'bootstrap-vue'

import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

import vuetify from './plugins/vuetify'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueToastr from "vue-toastr";

import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/locale/pt-br';

import "../src/design/app.scss";

import store from '@/state/store'

import App from './App.vue'

import { initFirebaseBackend } from './authUtils'
import i18n from './i18n'

import { configureFakeBackend } from './helpers/fake-backend';

import tinymce from 'vue-tinymce-editor'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}


Vue.component('b-button', BButton)


import Vuetify from 'vuetify'
Vue.use(Vuetify)

Vue.component('tinymce', tinymce)
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false


Vue.mixin({
  methods: {
    mensagem(mensagem, titulo="", tipo="success"){
      this.$swal({
          title: titulo,
          text: mensagem,
          icon: tipo,
          allowOutsideClick:false,
          confirmButtonText: 'Ok',
      })
    },
    mensagemErro(texto){
      this.mensagem(texto, "Mixin Global", "error")
    }
  },
})

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(BootstrapVueIcons)

Vue.use(VueToastr, {
  /* OverWrite Plugin Options if you need */
});

Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(DatePicker);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)


Vue.filter('real', valor => {
	return `R$ ${parseFloat(valor).toFixed(2)}`.replace('.', ',')
})
Vue.filter('dolar', valor => {
	return `US$ ${parseFloat(valor).toFixed(2)}`.replace('.', ',')
})
Vue.filter('guarani', valor => {
	return `G$ ${parseFloat(valor).toFixed(0)}`.replace(',', '.')
})
Vue.filter('peso', valor => {
	return `P$ ${parseFloat(valor).toFixed(2)}`.replace('.', ',')
})

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
